var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-detail-comments" },
    [
      _c(
        "div",
        { staticClass: "go-comments-header" },
        [
          _c("CreateComment", {
            key: _vm.forceRender,
            on: {
              selectFiles: _vm.onSelectFiles,
              onChangePrivate: _vm.onChangePrivate,
              onChangeComment: _vm.onChangeComment,
              onSubmitComment: _vm.onSubmitComment,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isPrivateFilter ||
      (_vm.storedComments && _vm.storedComments.length > 0)
        ? [
            _c("ShowComment", {
              attrs: {
                userId: _vm.userId,
                comments: _vm.comments,
                ownerId: _vm.getOwnerUser(),
                closeReply: _vm.closeReply,
              },
              on: {
                onClickLike: _vm.onClickLike,
                onClickDislike: _vm.onClickLike,
                remove: _vm.removeComment,
                submitReply: _vm.onSubmitSubComment,
                initComment: _vm.initComment,
                getAllComments: _vm.onModifyComment,
                onChangePrivate: _vm.onChangePrivateComments,
                onChangeSort: _vm.onChangeSort,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "total",
                    fn: function () {
                      return [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.comments.length === 0 ? 0 : _vm.total)
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "commentInComment",
                    fn: function (ref) {
                      var parentId = ref.parentId
                      return [
                        _c("CreateComment", {
                          key: _vm.forceRender,
                          attrs: {
                            isReply: "",
                            checkbox: parentId,
                            parentId: parentId,
                          },
                          on: {
                            selectFiles: _vm.onSelectFiles,
                            onChangePrivate: _vm.onChangePrivate,
                            onChangeComment: _vm.onChangeComment,
                            onSubmitComment: _vm.onSubmitComment,
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                117347544
              ),
            }),
            _vm._v(" "),
            _vm.comments && _vm.comments.length > 0
              ? _c("Pagination", {
                  attrs: { total: _vm.total },
                  on: {
                    goToPrevious: _vm.getAllComments,
                    goToNext: _vm.getAllComments,
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }